import { render, staticRenderFns } from "./ReinvestProjectsList.vue?vue&type=template&id=5c61690f&"
import script from "./ReinvestProjectsList.vue?vue&type=script&lang=js&"
export * from "./ReinvestProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports